import sessionReducer from './session/reducer';
import dataReducer from './data/reducer';

export default {
  session: sessionReducer,
  data: dataReducer
};
